<template>
  <f-dashboard-content-wrapper>
    <entrepreneur-card
      v-if="entrepreneur"
      class="m-bottom-20"
      :id="entrepreneur._id"
    ></entrepreneur-card>
    
    <router-view
      v-if="entrepreneur"
    ></router-view>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { computed, ref, nextTick } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import { useDate, formatDate } from '@composables/use-date'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import EntrepreneurCard from '@components/entrepreneurs/view/entrepreneur-card'

  export default {
    async setup () {
      const { get, fetch, patch, remove } = useStore('@freebe/entrepreneurs')
      const { checkPermissions } = useRoles()

      const userId = computed(() => router.currentRoute.value.params.id)
      const entrepreneurId = computed(() => 
        router.currentRoute.value.params.entrepreneur_id
      )
      const entrepreneur = computed(() =>
        get(entrepreneurId.value)
      )

      if (!checkPermissions('freebe/entrepreneurs:get')) {
        router.replace({ 
          name: 'user-profile',
          params: {
            id: userId.value
          } 
        })
      } else {
        if (!entrepreneur.value) {
          try {
            const fetched = await fetch(userId.value, { query: { user_id: userId.value } })

            const { name, params } = router.currentRoute.value

            router.replace({
              name: name,
              params: {
                ...params,
                entrepreneur_id: fetched._id
              }
            })
          } catch (error) {
            console.error('NOTIFICATION', error)
          }
        }
      }

      return {
        entrepreneur,
      }
    },

    components: {
      EntrepreneurCard,
    }
  }
</script>